import { View, StyleSheet, TouchableOpacity } from "react-native";
import { Icon, Text, theme, typography } from "ui-components";
import GiftPointsEarned from "../../../../assets/gift-points-earned";

interface PaymentSubmittedPointsEarnedCardProps {
  testID: string;
  accessibilityLabel?: string;
  title?: string;
  subTitle?: string;
  bodyTitle?: string;
  bodyDescription?: string;
  learnMoreText?: string;
  onPressLearnMore?: any;
}
export const PaymentSubmittedPointsEarnedCard = ({
  testID,
  accessibilityLabel,
  title,
  subTitle,
  bodyTitle,
  bodyDescription,
  learnMoreText = "Learn More",
  onPressLearnMore,
}: PaymentSubmittedPointsEarnedCardProps) => {
  return (
    <View style={styles.container} testID={testID} accessibilityLabel={accessibilityLabel}>
      <View style={styles.learnMoreButtonContainer}>
        <TouchableOpacity
          testID={testID + "-learn-more-button"}
          accessibilityLabel={accessibilityLabel + " learn more button"}
          style={styles.learnMoreButton}
          onPress={onPressLearnMore}
          activeOpacity={0.6}>
          <Text
            testID={testID + "-learn-more-button-text"}
            accessibilityLabel={accessibilityLabel + " learn more button text"}
            style={styles.learnMoreTextStyle}>
            {learnMoreText}
          </Text>
          <Icon
            testID={testID + "-learn-more-button-icon"}
            name="direction-right"
            size={16}
            strokeWidth={2}
            color={theme.colors.primary}
          />
        </TouchableOpacity>
      </View>
      <View style={{ alignSelf: "center" }}>
        <GiftPointsEarned />
      </View>
      <Text
        style={styles.titleStyle}
        testID={testID + "-title"}
        accessibilityLabel={accessibilityLabel + " title"}>{`${title}`}</Text>
      <Text
        style={styles.subTitleStyle}
        testID={testID + "-sub-title"}
        accessibilityLabel={accessibilityLabel + " sub title"}>{`${subTitle}`}</Text>
      <Text
        style={styles.bodyTitleStyle}
        testID={testID + "-body-title"}
        accessibilityLabel={accessibilityLabel + " body title"}>{`${bodyTitle}`}</Text>
      <Text
        style={styles.bodyDescriptionStyle}
        testID={testID + "-body-description"}
        accessibilityLabel={accessibilityLabel + " body description"}>{`${bodyDescription}`}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {},
  titleStyle: {
    ...typography.title2,
    marginTop: 5,
    color: theme.colors.primary,
    textAlign: "center",
    fontWeight: "500",
  },
  subTitleStyle: {
    ...typography.subHeading,
    color: theme.colors.text3,
    textAlign: "center",
    fontWeight: "500",
  },
  bodyTitleStyle: {
    ...typography.body,
    marginTop: 8,
    color: theme.colors.warning,
    textAlign: "center",
    fontWeight: "500",
  },
  bodyDescriptionStyle: {
    ...typography.body,
    color: theme.colors.text3,
    textAlign: "center",
    fontWeight: "500",
  },
  learnMoreButtonContainer: {
    position: "absolute",
    right: 0,
  },
  learnMoreButton: {
    flexDirection: "row",
    alignItems: "center",
    padding: 1,
    outlineStyle: "none",
    justifyContent: "center",
  },
  learnMoreTextStyle: {
    ...typography.body,
    fontWeight: "500",
    color: theme.colors.primary,
    marginRight: 4,
  },
});
